import { Tabs } from '@mantine/core';
import { useEffect, useState } from 'react';
import { tabStyles } from '../../../../../utils/helpers';
import { Table } from '../table';

const tabs = [
  {
    label: 'Brewing Ref SKU',
    value: 'brewing',
  },
  {
    label: 'Packaging Ref SKU',
    value: 'packaging',
  },
];

const Dual = (props) => {
  const { packagingRefSku, brewingRefSku, plantId, dualRefSelections, previewOnly } = props;
  const [type, setType] = useState('brewing');

  useEffect(() => {
    if (previewOnly) setType('brewing');
  }, [previewOnly]);

  const getReferenceSkus = () => {
    const { skus, requestedSku } = props;

    const referenceSkus = ((previewOnly ? [skus[type === 'brewing' ? 1 : 0]] : skus) || []).map(
      (sku) => {
        return {
          ...sku,
          type:
            type === 'brewing'
              ? sku?.brand === requestedSku?.brand
                ? 'Recommended'
                : ''
              : sku?.container === requestedSku?.container ||
                (sku?.container_size === requestedSku?.container_size &&
                  sku?.container_unit === requestedSku?.container_unit)
              ? 'Recommended'
              : '',
        };
      },
    );

    return referenceSkus;
  };

  return (
    <Tabs
      keepMounted={false}
      value={type}
      onTabChange={(value) => setType(value)}
      variant='unstyled'
      styles={tabStyles}
      className='prod-dev-tabs'
      color='#e5b611'
    >
      <Tabs.List>
        {tabs.map(({ label, value }, index) => (
          <Tabs.Tab value={value} className='menu-tabs' key={index}>
            <span>{label}</span>
          </Tabs.Tab>
        ))}
      </Tabs.List>

      {tabs.map(({ value }, index) => (
        <Tabs.Panel value={value} key={index}>
          <Table
            {...props}
            skus={getReferenceSkus()}
            selectedSkus={dualRefSelections?.[value] || {}}
            isDual={true}
            tabName={value}
            selectedSkusDetails={
              value === 'brewing' ? brewingRefSku[plantId] : packagingRefSku[plantId] || {}
            }
          />
        </Tabs.Panel>
      ))}
    </Tabs>
  );
};

export default Dual;
